import type { TemplateField } from '@/modules/template';

/**
 * Event-specific fields an author can inject into the share form. The event's
 * message fields already live in the tone itself, and its date/time is supplied
 * by primitives (e.g. `{_smartStartDate}`), so there are no extra
 * injectable fields yet. The seam is here for when the event form gains
 * type-specific insertable fields.
 */
export const eventInjectableFields: readonly TemplateField[] = [];
